import { Typography } from '@mui/material';
import { FieldErrors, useFormContext } from 'react-hook-form';

import { EmploymentBusinessCategorySelection } from '@/components/Form/Employment/EmploymentBusinessCategorySelection';
import { Select } from '@/components/Form/Select';
import { TextInput } from '@/components/Form/TextInput';

import { EMPLOYER_MAX_LENGTH } from '@/constants/places';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs';

import { UpdatePersonalInfo } from '../types';

type CaymanSelfEmployedFormSectionProps = {
  visibleErrors: FieldErrors<UpdatePersonalInfo>;
};

export function CaymanSelfEmployedFormSection({
  visibleErrors,
}: Readonly<CaymanSelfEmployedFormSectionProps>) {
  const { employmentDetailed } = visibleErrors;
  const { t } = useTranslate();
  const { control } = useFormContext<UpdatePersonalInfo>();
  const { occupations } = useAppSelector(selectConfigsState);

  return (
    <>
      <Typography variant="caption">
        {t('updatePersonalInfo.employmentInfoForm.field.businessName.label')}
      </Typography>
      <TextInput
        name="employmentDetailed.employerName"
        control={control}
        error={!!employmentDetailed?.employerName}
        helperText={employmentDetailed?.employerName?.message}
        fullWidth
        rules={{
          required: t(
            'updatePersonalInfo.employmentInfoForm.field.businessName.error.required',
          ),
          maxLength: {
            value: EMPLOYER_MAX_LENGTH.employerName,
            message: t(
              'updatePersonalInfo.employmentInfoForm.field.businessName.error.maxLength',
              {
                number: EMPLOYER_MAX_LENGTH.employerName,
              },
            ),
          },
        }}
      />
      <Typography variant="caption">
        {t('employerForm.form.businessCategory.label')}
      </Typography>
      <EmploymentBusinessCategorySelection<UpdatePersonalInfo>
        control={control}
        name="employmentDetailed.businessCategoryCode"
        label={''}
      />
      <Typography variant="caption">
        {t('updatePersonalInfo.employmentInfoForm.field.occupationCode.label')}
      </Typography>
      <Select
        options={occupations}
        control={control}
        name="employmentDetailed.occupationCode"
        error={!!employmentDetailed?.occupationCode}
        helperText={employmentDetailed?.occupationCode?.message}
        fullWidth
        placeholder={t(
          'updatePersonalInfo.employmentInfoForm.field.occupationCode.placeholder',
        )}
        rules={{
          required: t(
            'updatePersonalInfo.employmentInfoForm.field.occupationCode.error.required',
          ),
        }}
        useDrawerOnMobile
        withSearchBar
      />
    </>
  );
}
